import React from 'react'

const CompanyHeader = () => {
  return (
    <div className="channel-list__header">
        <p className="channel-list__header__text">Chat Web App</p>
    </div>
  )
}

export default CompanyHeader